var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('app-bread-crumbs',{staticClass:"capitalize",attrs:{"routes":[
      { name: 'home', title: 'accueil' },
      { name: 'findOutMore', title: 'Qui sommes-nous ?' },
    ]}}),_c('app-who-are-we',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }